/*
 * Created by Joseph Saliba on 12/16/16.
 */
namespace app.model {
  export enum SortDirection {
    ASC,
    DESC
  }
}
(window as any).SortDirection = app.model.SortDirection;
